import styled from "styled-components";

const Title = styled.h2`
  margin: ${({ theme }) => theme.space[3]} 0;
  font-family: ${(props) => props.theme.fonts.action};
  font-size: ${(props) => props.theme.fontSizes[5]};
  font-weight: bold;
  font-style: italic;
  text-transform: capitalize;
`;

export default Title;
